export default {
  methods: {
    extractQuota (ticket) {
      return (ticket.activeStake.Factor / 100)
    },
    extractHomeTeamName: function (ticket) {
      if (ticket && ticket.Matches && ticket.Matches.length > 0) {
        return ticket.Matches[0].HomeTeam
      }
      return ''
    },
    extractAwayTeamName: function (ticket) {
      if (ticket && ticket.Matches && ticket.Matches.length > 0) {
        return ticket.Matches[0].AwayTeam
      }
      return ''
    },
    extractMatchNo: function (ticket) {
      if (ticket && ticket.Matches && ticket.Matches.length > 0 && ticket.Matches[0].MatchNo) {
        return ticket.Matches[0].MatchNo
      } else {
        return -1
      }
    }
  }
}
